var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialIcon8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2362",
    "data-name": "Rectangle 2362",
    width: 31,
    height: 31,
    transform: "translate(0 0)",
    fill: "#101b2d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10396",
    "data-name": "Group 10396",
    transform: "translate(0.342 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10395",
    "data-name": "Group 10395",
    transform: "translate(-0.342 0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29372",
    "data-name": "Path 29372",
    d: "M25.989,9.173H24.46V4.586A4.588,4.588,0,0,0,19.874,0H4.586A4.588,4.588,0,0,0,0,4.586V22.932A1.523,1.523,0,0,0,.948,24.34a1.333,1.333,0,0,0,.581.12,1.525,1.525,0,0,0,1.082-.446l4.3-4.307H9.173v2.2a4.588,4.588,0,0,0,4.586,4.586H24.34l3.624,3.638a1.525,1.525,0,0,0,1.082.446,1.333,1.333,0,0,0,.581-.12,1.523,1.523,0,0,0,.948-1.409V13.759a4.588,4.588,0,0,0-4.586-4.586M9.173,13.759v2.89H6.282A1.525,1.525,0,0,0,5.2,17.1L3.058,19.244V4.586A1.529,1.529,0,0,1,4.586,3.058H19.874A1.529,1.529,0,0,1,21.4,4.586V9.173H13.759a4.588,4.588,0,0,0-4.586,4.586m18.345,11.6-1.529-1.529a1.543,1.543,0,0,0-1.082-.453H13.759a1.529,1.529,0,0,1-1.529-1.529v-8.09a1.529,1.529,0,0,1,1.529-1.529h12.23a1.529,1.529,0,0,1,1.529,1.529Z",
    transform: "translate(0.424 -0.001)",
    fill: "#101b2d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon8);
export default __webpack_public_path__ + "static/media/social_icon8.bd4bb9442cf42e02287c6b6a986f9dc4.svg";
export { ForwardRef as ReactComponent };